<template>
  <div>
    <banner />
    <div class="absolutecont">
      <div class="web">
        <div class="commonbg">
          <tab cur="/product" />
          <div class="newsWrapcontent">
            <div class="newsWrapxq">
              <div class="commonDetailed">
                <div class="commonDetailedtitle">
                  <h3>2020年第一届中国城市智慧视觉产业峰会成功举办</h3>
                  <div class="commonDetailedtitleTimeAuthor">
                    <span>2020.10.19&nbsp;&nbsp;&nbsp;华启科技</span>
                    <div class="bdsharebuttonbox bdshare-button-style0-16" style="display: inline;" data-bd-bind="1499078900829">
                    </div>
                  </div>
                </div>

                <div class="commonDetailedContents">
                  <p style=";text-align: left;text-indent: 28px"><span style="color: rgb(0, 0, 0); font-family: 微软雅黑,Microsoft YaHei; font-size: 14px;">蓬勃发展的数字经济时代，人类社会正朝着万物感知、万物互联、万物智能的智能社会快步前进。作为智能世界的眼睛，机器视觉利用视频+AI+大数据的能力，让智能视频和数据分析不仅仅应用于安全保障，更逐步成为各行各业的全新生产力，成为未来智慧城市、智慧生产、智慧生活的强大引擎。<br/></span></p>
                  <p style=";text-align: left;text-indent: 28px"><span style="color: rgb(0, 0, 0); font-family: 微软雅黑,Microsoft YaHei; font-size: 14px;"><br/></span></p>
                  <p style=";text-align: left;text-indent: 28px"><span style="color: rgb(0, 0, 0); font-family: 微软雅黑,Microsoft YaHei; font-size: 14px;">2020首届中国（南昌）城市智慧视觉产业峰会近日在江西南昌开幕，国内智慧城市领域的领军学术专家、知名企业家、智慧视觉产业上下游生态伙伴共计300余人到会。会议期间，与会人员专程参观考察南昌临空经济区与华为公司合作共建的城市智慧视觉创新中心以及睿聪科技生产线，并就深化合作召开座谈会。<br/></span></p>
                  <p style=";text-align: left;text-indent: 28px"><span style="color: rgb(0, 0, 0); font-family: 微软雅黑,Microsoft YaHei; font-size: 14px;"><br/></span></p>
                  <p style=";text-align: left;text-indent: 28px"><span style="color: rgb(0, 0, 0); font-family: 微软雅黑,Microsoft YaHei; font-size: 14px;"><br/>此次峰会主题为“智慧视觉，助力新型智慧城市建设”，由江西省工业和信息化厅、南昌市、华为技术有限公司联合主办。峰会汇聚行业先锋、生态伙伴共同驱动智慧视觉技术创新与建设，旨在结合新型智慧城市规划和建设，将南昌打造为“智慧视觉第一城”，同时在南昌构建智慧视觉产业生态，推动两者有机结合、良性循环，加速城市生命体中千行百业的数字化转型与智能化升级，赋能数字经济蓬勃发展。</span></p>
                  <p style=";text-align: left;text-indent: 28px"><span style="color: rgb(0, 0, 0); font-family: 微软雅黑,Microsoft YaHei; font-size: 14px;"><br/></span></p>
                  <p><img  style="" :src="baseApi+'upload/news/20201112102448.png'"/></p>
                </div>
                <div class="commonDetailedContentsfoot">
                  <p><router-link to="/product">返回</router-link></p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/views/news/componets/Banner'
import Tab from '@/views/news/componets/Tab'
export default {
  components: { Banner, Tab },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/news/product1.vue